import {
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector,
    GridToolbarExport
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import {Refresh, Replay} from "@mui/icons-material";
import isNull from "../../mixin/isNull";

export default function ({onResetFilter, customComponents, onRefresh}) {
    return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton
                slotProps={{tooltip: {title: "Gérer les colonnes"}}}
            />
            <GridToolbarDensitySelector
                slotProps={{tooltip: {title: 'Changer la densité'}}}
            />
            <Button startIcon={<Replay/>} size="small" onClick={onResetFilter}>
                Réinitialiser les filtres
            </Button>
            {
                !isNull(onRefresh)
                    ? (
                        <Button startIcon={<Refresh/>} onClick={onRefresh} size="small"
                                title="Les données sont actualisées automatiquement. À utiliser de manière exceptionnelle.">
                            Actualiser
                        </Button>
                    )
                    : null
            }
            <GridToolbarExport
                slotProps={{
                    tooltip: {title: 'Exporter les données'},
                    button: {variant: 'text', color: "primary", size: "small"},
                }}
            />
            <Box sx={{flexGrow: 1}}/>
            {
                customComponents.map((component, index) => (
                    <div key={index}>
                        {component}
                    </div>
                ))
            }
        </GridToolbarContainer>
    );
}